/**
 * A lightweight alternative to using moment.js
 *
 * No Dependencies
 */
export default class DateFormat {

	static DAYS_OF_WEEK = [
		'Sunday',
		'Monday',
		'Tuesday',
		'Wednesday',
		'Thursday',
		'Friday',
		'Saturday',
	];

	static MONTHS = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];

	static ISO_8601 = 'yyyy-mm-dd';
	static COMPACT = 'dd/mm/yy';
	static NICE = 'd mmm yyyy';
	static OFFERS = 'dddd mmm yyyy';
	static CALENDAR = 'dd mmmm, yyyy';

	/**
	 * @param {Date} date
	 * @param {String} format
	 * @return {String}
	 */
	static format(date, format) {
		switch (format) {
			case DateFormat.ISO_8601:
				return [
					DateFormat.#getYear(date, 'yyyy'),
					DateFormat.#getMonth(date, 'mm'),
					DateFormat.#getDate(date, 'dd'),
				].join('-');
			case DateFormat.COMPACT:
				return [
					DateFormat.#getDate(date, 'dd'),
					DateFormat.#getMonth(date, 'mm'),
					DateFormat.#getYear(date, 'yy')
				].join('/');
			case DateFormat.NICE:
				return [
					DateFormat.#getDate(date, 'd'),
					DateFormat.#getMonth(date, 'mmm'),
					DateFormat.#getYear(date, 'yyyy'),
				].join(' ');
			case DateFormat.OFFERS:
				return [
					DateFormat.#getDate(date, 'dddd') + ',',
					DateFormat.#getMonth(date, 'mmm'),
					DateFormat.#getYear(date, 'yyyy'),
				].join(' ');
			case DateFormat.CALENDAR:
				return [
					DateFormat.#getDate(date, 'dd'),
					DateFormat.#getMonth(date, 'mmmm') + ',',
					DateFormat.#getYear(date, 'yyyy'),
				].join(' ');
		}
	}

	/**
	 * @param {Date} date1
	 * @param {Date} date2
	 * @return {Number}
	 */
	static nights(date1, date2) {
		const oneDay = 1000 * 60 * 60 * 24;
		return Math.floor((date1 - date2) / oneDay);
	}

	/**
	 * @param {Date} date
	 * @param {Number} amount
	 * @returns {Date}
	 */
	static addDays(date, amount) {
		const newDate = new Date(+date);
		newDate.setDate(newDate.getDate() + amount);
		return newDate;
	}

	/**
	 * @param {Date} date
	 * @param {Number} amount
	 * @returns {Date}
	 */
	static subtractDays(date, amount) {
		const newDate = new Date(+date);
		newDate.setDate(newDate.getDate() - amount);
		return newDate;
	}

	/**
	 * @param {Date} date
	 * @param {String} format
	 * @return {String}
	 */
	static #getYear(date, format) {
		if (format === 'yy') {
			return (date.getFullYear() + '').slice(2);
		} else {
			return date.getFullYear() + '';
		}
	}

	/**
	 * @param {Date} date
	 * @param {String} format
	 * @return {String}
	 */
	static #getMonth(date, format) {
		switch (format) {
			case 'm':
				return (date.getMonth() + 1) + '';
			case 'mm':
				return (date.getMonth() < 9) ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1) + '';
			case 'mmm':
				return DateFormat.MONTHS[date.getMonth()].slice(0, 3);
			case 'mmmm':
				return DateFormat.MONTHS[date.getMonth()];
			default:
				return DateFormat.MONTHS[date.getMonth()];
		}
	}

	/**
	 * @param {Date} date
	 * @param {String} format
	 * @return {String}
	 */
	static #getDate(date, format) {
		switch (format) {
			case 'd':
				return date.getDate() + '';
			case 'dd':
				return (date.getDate() < 10) ? '0' + date.getDate() : date.getDate() + '';
			case 'ddd':
				return DateFormat.DAYS_OF_WEEK[date.getDay()].slice(0, 3);
			case 'dddd':
				return DateFormat.DAYS_OF_WEEK[date.getDay()];
			default:
				return DateFormat.DAYS_OF_WEEK[date.getDay()];
		}
	}

	/**
	 * @param {Date|String} date
	 */
	static isValid(date) {
		if (date === 'Invalid Date') return false;
		return date.valueOf() !== 0;
	}

	static isValidCheckOut(checkIn, checkOut) {
		const minDate = DateFormat.addDays(checkIn, 1);
		return minDate <= checkOut;
	}

};

